import { CLICK_KEYS, UTM_KEYS, value } from "./attribution.js"

// Copies the ad click identifier and campaign a visitor arrived with onto the
// download link, so the download host's request log records which ad the
// download came from. Nothing is stored in the browser, so a visitor who
// moves on from the page the ad opened downloads without it.
export const trackedDownloadUrl = (base, search) => {
  const params = new URLSearchParams(search)
  const url = new URL(base)
  let changed = false
  for (const key of [...CLICK_KEYS, ...UTM_KEYS]) {
    const text = value(params, key)
    if (text) {
      url.searchParams.set(key, text)
      changed = true
    }
  }
  return changed ? url.href : base
}

export const trackDownloads = (document, search) => {
  for (const link of document.querySelectorAll("a[download]")) {
    link.href = trackedDownloadUrl(link.href, search)
  }
}

if (typeof document !== "undefined") {
  document.addEventListener("DOMContentLoaded", () => trackDownloads(document, window.location.search))
}
